import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "./i18n/LangContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Services from "./components/Services";
import CareTips from "./components/CareTips";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import IntroSplash from "./components/IntroSplash";
import { WHATSAPP_URL } from "./constants/site";

export default function App() {
    const [introDone, setIntroDone] = useState(false);
    const lenisRef = useRef(null);

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        lenisRef.current = lenis;
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    useEffect(() => {
        const t = setTimeout(() => setIntroDone(true), 3000);
        return () => clearTimeout(t);
    }, []);

    useEffect(() => {
        if (!lenisRef.current) return;
        if (introDone) {
            lenisRef.current.start();
        } else {
            lenisRef.current.stop();
        }
    }, [introDone]);

    return (
        <LangProvider>
            <div className="wine-noir font-sans text-cream antialiased">
                <AnimatePresence>{!introDone && <IntroSplash />}</AnimatePresence>
                <div className="grain-overlay animate-grain" aria-hidden="true" />
                <Navbar />
                <main>
                    <Hero />
                    <Marquee />
                    <Services />
                    <CareTips />
                    <Faq />
                    <Contact />
                </main>
                <Footer />
                <Toaster
                    theme="light"
                    position="bottom-center"
                    toastOptions={{
                        style: {
                            background: "#F6F1EB",
                            border: "1px solid rgba(138,116,86,0.35)",
                            color: "#4E3826",
                        },
                    }}
                />
                <a
                    data-testid="whatsapp-float-button"
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Agendar pelo WhatsApp"
                    className="group fixed bottom-6 right-6 z-50"
                >
                    <span className="absolute inset-0 animate-ping rounded-full bg-gold/30" />
                    <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-gold text-noir shadow-[0_10px_40px_rgba(196,162,119,0.4)] transition-all duration-300 group-hover:scale-110 group-hover:bg-burnt">
                        <MessageCircle className="h-6 w-6" />
                    </span>
                </a>
            </div>
        </LangProvider>
    );
}
